<script setup lang="ts">
/**
 * App.vue — root component
 * Applies the theme data attribute and renders the router view.
 */
import ConfirmDialog from 'primevue/confirmdialog'
import RIconSheet from '@/components/atoms/RIconSheet.vue'
import { usePreferencesStore } from '@/stores/preferences'
const preferences = usePreferencesStore()
</script>

<template>
  <div
    id="app"
    :data-theme="preferences.sombre ? 'dark' : 'light'"
  >
    <RIconSheet />
    <RouterView />
    <!-- Annuler en secondaire dans toutes les confirmations : l'action confirmée reste seule mise en avant -->
    <!-- Largeur bornée : un long message passe à la ligne au lieu d'étirer la fenêtre -->
    <ConfirmDialog
      :pt="{
        root: { style: { maxWidth: 'min(40rem, calc(100vw - 2rem))' } },
        pcRejectButton: { root: { class: 'p-button-secondary' } },
      }"
    >
      <template #message="{ message }">
        <span
          v-if="message.icon"
          :class="[message.icon, 'p-confirmdialog-icon']"
        />
        <span class="p-confirmdialog-message">
          {{ message.message }}
          <template v-if="message.irreversible"> <br><br><strong>Cette action est irréversible.</strong> </template>
        </span>
      </template>
    </ConfirmDialog>
  </div>
</template>

<style scoped lang="scss">
#app {
  min-height: 100dvh;
}
</style>
